<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app>
    <app-sidebar v-if="menuLocation === 'sidebar' || $vuetify.breakpoint.mdAndDown" />

    <v-fade-transition>
      <v-col class="pa-2" cols="12" style="position: fixed; bottom: 0; right: 0; z-index: 300;"
             v-if="showNotificationBalance">
        <v-card class="error" style="cursor: pointer" @click="hideBalanceNotification = true">
          <v-card-text>
            <v-row class="white--text">
              <v-col cols="12" class="layout align-center justify-space-between">
                <span class="mr-4">No hay saldo en esta compañía.</span>
                <v-btn v-if="$store.getters.companyStripeId"
                       dark
                       outlined
                       @click="$store.commit('TOGGLE_NEW_PAYMENT_DIALOG', true)">
                  Cargar
                </v-btn>

                <v-btn v-else
                       dark
                       outlined
                       @click="$router.push(`/settings`)">
                  Agregar Tarjeta
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-fade-transition>

    <AppToolbar :toolbar-config="toolbarConfig" v-show="!isTableEditingMode" />

    <v-main class="kbLight"
            :style="{
                    paddingTop: contentComponentPaddingTop
                }">
      <app-template :transitionName="transitionName"/>
    </v-main>
    <ImporterProgress v-if="importerProgress.show"/>
    <WarningPaymentState/>
  </v-app>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
import AppToolbar from '@/components/AppToolBar/AppToolbar.vue'
import AppSidebar from '@/components/AppSideBar/AppSidebar.vue'
import AppTemplate from '@/pages/App/AppTemplate.vue'
import ImporterProgress from '@/components/ui/ImporterProgress.vue'
import WarningPaymentState from '@/pages/App/Billing/dialogs/WarningPaymentState.vue'

export default {
  components: { AppToolbar, AppSidebar, AppTemplate, ImporterProgress, WarningPaymentState },
  computed: {
    ...mapGetters(['appUuid', 'companyUuid', 'isAdmin', 'isSuperAdmin', 'businessModule']),
    ...mapState({
      companyBalance: state => state.companies.selectedCompany.balance,
      importerProgress: state => state.listsPersons.importerProgress,
      isCloudTask: state => state.auth.isCloudTask,
      isDarkTheme: state => state.auth.isDarkTheme,
      isTableEditingMode: state => state.dataTables.isTableEditingMode,
      menuLocation: state => state.graphicAspect.menuLocation,
      selectedCompany: state => state.companies.selectedCompany,
      selectedApp: state => state.apps.selectedApp,
      userKeybe: state => state.auth.userKeybe
    }),
    contentComponentPaddingTop () {
      if (this.toolbarConfig.height === this.largeHeight || this.isTableEditingMode) return ''
      const paddingTop = this.toolbarConfig.height
      return `${paddingTop}px`
    },
    showNotificationBalance () {
      if (this.hideBalanceNotification) return false
      return this.selectedCompany && this.companyBalance <= 0 && !this.$store.getters.companyIsMonthlyBilling
    },
    toolbarConfig () {
      const { name: pathName } = this.$route
      let largeHeight = this.largeHeight
      let mediumHeight = this.mediumHeight
      const smallHeight = this.smallHeight
      if (this.menuLocation === 'toolbar') {
        largeHeight = smallHeight + 60
        mediumHeight = smallHeight
      }
      switch (pathName) {
        case 'Superuser Home':
          return { name: this.$t('toolbar.superDesktop'), icon: 'mdi-trending-up', color: 'kbGold', height: largeHeight }
        case 'Notificaciones':
          return { name: this.$t('toolbar.appNotifications'), icon: 'mdi-bell-outline', color: 'kbGold', height: mediumHeight }
        case 'Home':
          return {
            name: this.$t('sidebar.panel'),
            image: 'https://storage.googleapis.com/keybe/dashboard-icons/home-white.svg',
            color: 'kbSemiDarkBlue',
            height: largeHeight
          }
        case 'PeopleDirectory':
          return { name: this.$t('toolbar.peopleDirectory'), icon: 'feather-users', color: 'kbPink', height: mediumHeight }
        case 'Lists Persons':
          return { name: this.$t('toolbar.peopleList'), icon: 'mdi-format-list-bulleted', color: 'kbPink', height: mediumHeight }
        case 'ListDetails':
          return { name: this.$t('toolbar.listDetails'), icon: 'mdi-format-list-bulleted', color: 'kbPink', height: mediumHeight }
        case 'Roles':
          return { name: this.$t('toolbar.roles'), icon: 'mdi-account-multiple-outline', color: 'kbPink', height: mediumHeight }
        case 'Conversaciones':
          return {
            name: this.$t('toolbar.conversations'),
            icon: '',
            image: 'https://storage.googleapis.com/keybe/cloudtask/conversa2-blanco.svg',
            color: 'kbGreen',
            height: smallHeight
          }
        case 'ConversationMetrics':
          return { name: this.$t('toolbar.conversationMetrics'), icon: 'mdi-finance', color: 'kbGreen', height: largeHeight }
        case 'EmailSettings':
          return { name: this.$t('toolbar.emailSettings'), icon: 'mdi-chat-processing', color: 'kbPurple', height: mediumHeight }
        case 'ConversationSettings':
          return { name: this.$t('toolbar.conversationSettings'), icon: 'mdi-chat-processing', color: 'kbGreen', height: mediumHeight }
        case 'Negocios':
          return { name: this.businessModule.p, icon: 'feather-dollar-sign', color: 'kbRed', height: mediumHeight }
        case 'Negocios Detalle':
          return { name: `${this.$t('toolbar.details')} ${this.businessModule.s}`, icon: 'mdi-factory', color: 'kbRed', height: mediumHeight }
        case 'Campaigns':
          return { name: this.$t('toolbar.campaigns'), icon: 'mdi-account-voice', color: 'kbPurple', height: mediumHeight }
        case 'New Sms':
          return { name: this.$t('toolbar.newSms'), icon: 'mdi-message-processing', color: 'kbPurple', height: mediumHeight }
        case 'New Campaign':
          return { name: this.$t('toolbar.newCampaign'), icon: 'mdi-account-voice', color: 'kbPurple', height: mediumHeight }
        case 'Detalles de Campana':
          return { name: this.$t('toolbar.campaignDetails'), icon: 'mdi-account-voice', color: 'kbPurple', height: mediumHeight }
        case 'Disparadores':
          return { name: this.$t('toolbar.triggers'), icon: 'mdi-flash-outline', color: 'kbPurple', height: mediumHeight }
        case 'Notifications':
          return { name: this.$t('toolbar.notifications'), icon: 'mdi-bell-outline', color: 'kbPurple', height: mediumHeight }
        case 'Proyectos de Speech To Text':
          return { name: this.$t('toolbar.speechToText'), icon: 'settings_voice', color: 'kbOrange', height: mediumHeight }
        case 'Keybe UI':
          return { name: this.$t('toolbar.authenticator'), icon: 'mdi-account-circle-outline', color: 'kbBlue', height: mediumHeight }
        case 'Formularios':
          return { name: this.$t('toolbar.forms'), icon: 'mdi-form-select', color: 'kbBlue', height: mediumHeight }
        case 'Nuevo Formulario':
          return { name: this.$t('toolbar.newForm'), icon: 'mdi-form-select', color: 'kbBlue', height: mediumHeight }
        case 'Editar Formulario':
          return { name: this.$t('toolbar.editForm'), icon: 'mdi-form-select', color: 'kbBlue', height: mediumHeight }
        case 'Eventos':
          return { name: this.$t('toolbar.events'), icon: 'mdi-ticket', color: 'kbGold', height: mediumHeight }
        case 'Categories':
          return { name: this.$t('toolbar.categories'), icon: 'mdi-hubspot', color: 'kbGold', height: mediumHeight }
        case 'EventCategories':
          return { name: this.$t('toolbar.categories'), icon: 'mdi-hubspot', color: 'kbGold', height: mediumHeight }
        case 'EventPreferences':
          return { name: this.$t('toolbar.preferences'), icon: 'mdi-hubspot', color: 'kbGold', height: mediumHeight }
        case 'Places':
          return { name: this.$t('toolbar.places'), icon: 'mdi-storefront', color: 'kbGold', height: mediumHeight }
        case 'PlaceCategories':
          return { name: this.$t('toolbar.categories'), icon: 'mdi-hubspot', color: 'kbGold', height: mediumHeight }
        case 'PlacePreferences':
          return { name: this.$t('toolbar.preferences'), icon: 'mdi-hubspot', color: 'kbGold', height: mediumHeight }
        case 'Eventos Detalle':
          return { name: this.$t('toolbar.eventDetail'), icon: 'mdi-ticket', color: 'kbGold', height: mediumHeight }
        case 'Asistentes':
          return { name: this.$t('toolbar.assistants'), icon: 'mdi-account-group', color: 'kbGold', height: mediumHeight }
        case 'Promotors':
          return { name: this.$t('toolbar.promotors'), icon: 'mdi-account-multiple-plus', color: 'kbGold', height: mediumHeight }
        case 'Djs':
          return { name: this.$t('toolbar.djs'), icon: 'mdi-account-multiple-plus', color: 'kbGold', height: mediumHeight }
        case 'ProductsCategories':
          return { name: this.$t('toolbar.productsCategories'), icon: 'mdi-glass-cocktail', color: 'kbGold', height: mediumHeight }
        case 'Products':
          return { name: this.$t('toolbar.products'), icon: 'mdi-glass-cocktail', color: 'kbGold', height: mediumHeight }
        case 'ProductsSales':
          return { name: this.$t('toolbar.productsSales'), icon: 'mdi-glass-cocktail', color: 'kbGold', height: mediumHeight }
        /* orders */
        case 'OrderClients':
          return { name: this.$t('toolbar.clients'), icon: 'mdi-account', color: 'kbGold', height: mediumHeight }
        case 'OrderColors':
          return { name: this.$t('toolbar.colors'), icon: 'mdi-palette', color: 'kbGold', height: mediumHeight }
        case 'OrderContainerTypes':
          return { name: this.$t('toolbar.containerTypes'), icon: 'mdi-truck', color: 'kbGold', height: mediumHeight }
        case 'OrderPurchases':
          return { name: this.$t('toolbar.purchases'), icon: 'feather-dollar-sign', color: 'kbGold', height: mediumHeight }
        case 'OrderPurchaseDetail':
          return { name: this.$t('toolbar.addProductsToPurchase'), icon: 'feather-dollar-sign', color: 'kbGold', height: mediumHeight }
        case 'OrderProducts':
          return { name: this.$t('toolbar.products'), icon: 'mdi-cart', color: 'kbGold', height: mediumHeight }
        case 'OrderSellers':
          return { name: this.$t('toolbar.sellers'), icon: 'mdi-account', color: 'kbGold', height: mediumHeight }
        case 'OrderSuppliers':
          return { name: this.$t('toolbar.suppliers'), icon: 'mdi-account', color: 'kbGold', height: mediumHeight }
        /* end orders */
        case 'Configuracion':
          return { name: this.$t('toolbar.settings'), icon: 'mdi-cog-outline', color: 'kbLightBlue', height: mediumHeight }
        case 'User Configuration':
          return { name: this.$t('sidebar.userConfiguration'), icon: 'mdi-account-cog', color: 'kbLightBlue', height: mediumHeight }
        case 'Detalles':
          return { name: this.$t('toolbar.details'), icon: 'mdi-card-account-details-outline', color: 'kbLightBlue', height: mediumHeight }
        case 'Administradores':
          return { name: this.$t('toolbar.administrators'), icon: 'mdi-account-check', color: 'kbLightBlue', height: mediumHeight }
        case 'DailyUsage':
          return { name: this.$t('toolbar.billing'), icon: 'mdi-card-text-outline', color: 'kbLightBlue', height: mediumHeight }
        case 'Payments':
          return { name: this.$t('toolbar.payments'), icon: 'mdi-cash-usd', color: 'kbLightBlue', height: mediumHeight }
        case 'Cards':
          return { name: this.$t('toolbar.creditCards'), icon: 'mdi-credit-card-multiple-outline', color: 'kbLightBlue', height: mediumHeight }
        case 'Nueva Aplicación':
          return { name: this.$t('toolbar.newApp'), icon: 'mdi-newspaper-variant', color: 'kbBlue', height: mediumHeight }
        case 'Nuevo Negocio':
          return { name: this.$t('toolbar.newCompany'), icon: 'mdi-domain', color: 'kbBlue', height: mediumHeight }
        case 'journey':
          return { name: 'journey', icon: 'mdi-sitemap', color: 'kbLightBlue', height: mediumHeight }
        case 'JourneyDetails':
          return { name: 'Journey details', icon: 'mdi-file-tree', color: 'kbLightBlue', height: mediumHeight }
        case 'Sequences':
          return { name: this.$t('sidebar.sequences'), icon: 'mdi-file-tree', color: 'kbPink', height: mediumHeight }
        case 'Sequences rules':
          return { name: this.$t('general.rules'), icon: 'mdi-ruler', color: 'kbPink', height: mediumHeight }
        case 'Sequence Details':
          return { name: this.$t('general.sequenceDetails'), icon: 'mdi-sitemap', color: 'kbPink', height: mediumHeight }
        case 'Sequence Leads':
          return { name: this.$t('general.sequenceLeads'), icon: 'mdi-sitemap', color: 'kbPink', height: mediumHeight }
        case 'Sequences Schedules':
          return { name: this.$t('general.schedules'), icon: 'mdi-calendar', color: 'kbPink', height: mediumHeight }
        case 'Sequence Statistics':
          return { name: this.$t('general.sequenceStatistics'), icon: 'mdi-chart-areaspline-variant', color: 'kbPink', height: mediumHeight }
        /* start realstate */
        case 'Real Estate':
          return { name: 'Real Estate', icon: 'feather-grid', color: 'abadPrimary', height: mediumHeight }
        case 'Create Property':
          return { name: 'Crear propiedad', icon: 'feather-grid', color: 'abadPrimary', height: mediumHeight }
        case 'Properties List':
          return { name: 'Propiedades', icon: 'feather-grid', color: 'abadPrimary', height: mediumHeight }
        case 'Advisers List':
          return { name: 'Asesores', icon: 'feather-grid', color: 'abadPrimary', height: mediumHeight }
        case 'Owners List':
          return { name: 'Propietarios', icon: 'feather-grid', color: 'abadPrimary', height: mediumHeight }
        case 'Emails':
          return { name: 'Emails', icon: 'mdi-email', color: 'kbSemiDarkBlue', height: mediumHeight }
        /* end realstate */
        default:
          return { name: this.$t('toolbar.newPage'), icon: 'mdi-earth', color: 'kbSemiDarkBlue', height: mediumHeight }
      }
    }
  },
  data () {
    return {
      hideBalanceNotification: false,
      largeHeight: 260,
      mediumHeight: 150,
      smallHeight: 64,
      transitionName: 'slide-left'
    }
  },
  async created () {
    await this.getAdminUserInfo()
    await this.initAdminUserExtraData()
  },
  destroyed () {
    delete this.$options.sockets.createListUser
  },
  methods: {
    async getAdminUserInfo () {
      try {
        const user = await this.$store.dispatch('getAdminUserInfo')
        this.$store.commit('SET_KEYBE_USER', user)
      } catch (e) {
        if (e.message === 'Network Error') {
          notifications.error('No hay conexión con el servidor')
        } else {
          notifications.error('Sesión inválida, por favor inicie sesión nuevamente')
          this.$store.dispatch('logout')
        }
      }
    },
    async initAdminUserExtraData () {
      const extraDataAndUpdateExtraDataFlag = this.initAdminUserAppExtraData()
      await this.initAdminUserGraphicAspectExtraData(
        extraDataAndUpdateExtraDataFlag.extraData,
        extraDataAndUpdateExtraDataFlag.updateAdminUserExtraDataFlag
      )
    },
    initAdminUserAppExtraData () {
      let updateAdminUserExtraDataFlag = false
      let { extraData = [] } = this.userKeybe

      if (this.$store.getters.appUuid) {
        const currentAppExtraData = { field: `APP_${this.$store.getters.appUuid.toUpperCase()}`, value: {}, access: 'app' }
        const foundCurrentAppExtraData = extraData.find(item => {
          if (item.field &&
            item.field.includes('APP_') &&
            item.field.split('_').length === 2) {
            const foundApiUuid = item.field.split('_')[1]
            return this.$store.getters.appUuid.toUpperCase() === foundApiUuid
          }
        })
        if (!foundCurrentAppExtraData) {
          extraData = [...extraData, currentAppExtraData]
          updateAdminUserExtraDataFlag = true
        }
      }
      return { extraData, updateAdminUserExtraDataFlag }
    },
    async initAdminUserGraphicAspectExtraData (extraData, updateAdminUserExtraDataFlag) {
      let isDarkTheme = false
      let menuLocation = 'sidebar'
      const graphicAspectExtraDataFoundItems = extraData
        .filter(item => {
          if (item.field === 'MENU_LOCATION') {
            menuLocation = item.value
            return item
          } else if (item.field === 'IS_DARK_THEME') {
            isDarkTheme = item.value === 'true'
            return item
          }
        })
      if (!graphicAspectExtraDataFoundItems.length) {
        const graphicAspectExtraData = [
          { field: 'IS_DARK_THEME', value: isDarkTheme, access: 'app' },
          { field: 'MENU_LOCATION', value: menuLocation, access: 'app' }
        ]
        extraData = [...extraData, ...graphicAspectExtraData]
        updateAdminUserExtraDataFlag = true
      }
      if (updateAdminUserExtraDataFlag) {
        const { extraData: userKeybeExtraData, ...all } = this.userKeybe
        this.$store.commit('SET_KEYBE_USER', { extraData, ...all })
        await this.$store.dispatch('updateAdminUserInfo', {
          extraData
        })
      }
      this.setAppGraphicAspect(isDarkTheme, menuLocation)
    },
    setAppGraphicAspect (isDarkTheme, menuLocation) {
      // Covering possible errors in MENU_LOCATION and/ or IS_DARK_THEME extraData values
      if (isDarkTheme !== true && isDarkTheme !== false) {
        isDarkTheme = false
      }
      if (menuLocation !== 'sidebar' && menuLocation !== 'toolbar') {
        menuLocation = 'sidebar'
      }
      this.$vuetify.theme.dark = isDarkTheme
      this.$store.commit('SET_MENU_LOCATION', menuLocation)
    },
    async getAdministrator () {
      const administratorId = this.$store.state.auth.userKeybe.UUID

      const data = {
        companyUuid: this.companyUuid,
        administratorId
      }

      await this.$store.dispatch('getAdministrator', data)
    }
  },
  watch: {
    async appUuid (value) {
      if (value) {
        await this.initAdminUserExtraData()
      }
    },
    companyUuid () {
      this.getAdministrator()
    },
    // watch the `$route` to determine the transition to use
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    },
    selectedCompany (value) {
      if (this.isSuperAdmin || this.isAdmin || this.$store.state.companies.administratorRoles.includes('ROLE_PAYMENTS')) {
        this.$store.dispatch('getListCreditCards')
      }

      this.hideBalanceNotification = false
      // Doing this temporary watcher to force user fill email and phone data if they are not set up
      // console.log('selectedCompany')
      // console.log(value)
      const isEmpty = function (obj) {
        for (var key in obj) {
          // eslint-disable-next-line no-prototype-builtins
          if (obj.hasOwnProperty(key)) {
            return false
          }
        }
        return true
      }
      if (value && !isEmpty(value)) {
        if (!value.email || value.email === null || !value.phone || value.phone === null) {
          notifications.error('Por favor complete los datos de la compañía')
          this.$router.push('/settings')
        }
      }
    }
  },
  sockets: {
    connect () {
      this.$socket.emit('room', { jwt: this.$store.getters.token })
    },
    notifications (data) {
      // notifications.info(data.message)
    },
    createList (data) {
      switch (data.code) {
        case 1:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            list: data.list,
            finish: false,
            show: true,
            index: data.index,
            totalUsers: data.totalUsers
          })
          break
        case 2:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            list: data.list,
            finish: true,
            importType: 'list',
            show: true,
            index: data.index,
            totalUsers: data.totalUsers
          })
          break
      }
    },
    createdUserResponse (data) {
      const importingObject = {
        index: data.index,
        numberOfRows: data.numberOfRows,
        totalRecords: data.totalRecords,
        totalUsers: data.totalUsers,
        uniqueRecords: data.uniqueRecords,
        savedRecords: data.savedRecords,
        updatedRecords: data.updatedRecords,
        insertedRecords: data.insertedRecords,
        duplicatedRecords: data.duplicatedRecords
      }
      switch (data.code) {
        case 1:
        case undefined:
        case null:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            finish: false,
            show: true,
            ...importingObject
          })
          break
        case 2:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            list: data.list,
            finish: true,
            importType: data.importType,
            show: true,
            ...importingObject
          })
          if (data.importType === 'campaigns' && data.list) return EventBus.$emit('updateCampaign', data.list)
          if (data.list) EventBus.$emit('updateList', data.list._id)
          break
        default:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            list: data.list,
            finish: false,
            show: true,
            ...importingObject
          })
      }
    },
    createdBusinessResponse (data) {
      switch (data.code) {
        case 1:
        case undefined:
        case null:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            index: data.index,
            finish: false,
            importType: 'business',
            show: true,
            totalUsers: data.totalUsers
          })
          break
        case 2:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            finish: true,
            importType: 'business',
            show: true,
            index: data.index,
            totalUsers: data.totalUsers
          })
          break
        default:
          this.$store.commit('SET_IMPORTER_PROGRESS', {
            finish: false,
            importType: 'business',
            show: true,
            index: data.index,
            totalUsers: data.totalUsers
          })
      }
    }
  }
}
</script>
<style>
html {
  overflow-y: auto;
}
</style>
